// @flow

// Libs

// Effect Managers
import { call, fork, all, take } from 'redux-saga/effects'

// Controller
import recomController from 'hfty-ctrl-recommendations'
import { controller as cropController } from 'fc-model-crops'

// Sagas
import watchRecommendationOperatoions from './operations'
import { watchOperations } from 'hfty-operator-recommendations'

// Selectors
import operations$ from '../selectors/operations'

// Constants
import {
  FETCH_HEFTY_CROPS,
  FETCH_RECOMMENDATIONS,
  FETCH_RECOMMENDATION_BY_ID,
} from '../constants'

// Sagas

export default function *main (): Generator<*, *, *> {
  yield all([
    call(recomController.start),
    call(cropController.start),
  ])
  yield fork(recomController.watch)
  yield fork(cropController.watch)

  yield fork(watchRecommendationOperatoions)

  // yield fork(watchFetchCrops)
  yield fork(fetchCrops)

  // yield fork(watchFetchRecommendations)
  yield call(recomController.read)

  yield fork(watchFetchRecommendationById)

  yield fork(watchOperations, { operations$ })
}

export function *watchFetchCrops (): Generator<*, *, *> {
  while (true) {
    yield take(FETCH_HEFTY_CROPS)
    yield call(cropController.read, {
      queryParams: {
        hefty: 'True',
      },
    })
  }
}

export function *fetchCrops (): Generator<*, *, *> {
  yield call(cropController.read, {
    queryParams: {
      hefty: 'True',
    },
  })
}

export function *watchFetchRecommendations (): Generator<*, *, *> {
  while (true) {
    yield take(FETCH_RECOMMENDATIONS)
    yield call(recomController.read)
  }
}

export function *watchFetchRecommendationById (): Generator<*, *, *> {
  while (true) {
    const { payload } = yield take(FETCH_RECOMMENDATION_BY_ID)
    yield call(recomController.read, {
      id: payload.recommendationId,
    })
  }
}
